// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/new_img/hero_bannerbg2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/images/new_img/get_standerdbg_after.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../public/images/new_img/get_standerdbg_before.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../public/images/new_img/ctabg_after.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.herobanner2 .scan_block {
  background-color: #0C0900;
  margin: -10px auto;
}

.banner_add_slide {
  margin: 80px 0px 60px;
  position: relative;
  z-index: 6666;
}

.banner_add_slide .heighlightcnt img {
  border-radius: 13px;
}

.banner_add_slide .slick-dots li button:before {
  font-size: 0px;
  background-color: #FFFBFB;
  left: 0;
  width: 10px;
  border-radius: 50px;
  height: 10px;
}

body .banner_add_slide .slick-dots li.slick-active button:before {
  width: 24px;
  background-color: #2563eb;
}

#popup-box.popup-box.homepop_box {
    width: 700px;
}

body .banner_add_slide .slick-dots li button {
  width: auto;
  height: auto;
}

body .banner_add_slide .slick-dots li {
  width: auto;
  height: auto;
}

body .banner_add_slide .slick-dots li.slick-active {
  width: 24px;
}


.herobanner2 {
  font-family: "Afacad", sans-serif;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
}

h2 {
  font-family: "Afacad", sans-serif;
}

h3 {
  font-family: "Afacad", sans-serif;
}

.how_get_account_ot ul li {
  font-family: "Afacad", sans-serif;
}

.how_get_account_ot ul li p {
  font-size: 22px;
}

.herobanner2 .banner_cnt {
  padding-top: 100px;
}

.herobanner2 .banner_cnt h3 {
  font-size: 35px;
  font-weight: 400;
  text-transform: capitalize;
}

.herobanner2 .banner_cnt h1 span {
  color: #2563eb;
}

.uptates_sm.market_update_outer h2 span {
  color: #2563eb;
}

.uptates_sm .trade_btn button {
  display: flex;
  align-items: center;
  gap: 24px;
}

.services_block {
  font-family: "Afacad", sans-serif;
}

.services_block h4 {
  font-size: 24px;
  font-weight: 600;
}

.services_block p {
  line-height: 24px;
}
.started_trading_s {
  position: relative;
}

.started_trading_s::before {
  position: absolute;
  right: 0px;
  content: "";
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: 28%;
  background-repeat: no-repeat;
  background-position: right;
  top: -620px;
  z-index: 333;
  left: inherit;
  width: 100%;
}

.started_trading_s .how_get_account_ot .trade_btn button {
  display: flex;
  align-items: center;
  gap: 24px;
}

.started_trading_s .trading_platform_section {
  background-color: transparent;
  position: relative;
  z-index: 666;
}

.started_trading_s .trading_platform_section h2 span {
  color: #2563eb;
  display: inline;
  padding-right: 10px;
}

.started_trading_s .services_block:hover {
  background-color: transparent;
}

.started_trading_s::after {
  position: absolute;
  left: 0px;
  content: "";
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 40%;
  background-repeat: no-repeat;
  background-position: left bottom;
  bottom: -300px;
  z-index: 333;
  right: inherit;
  width: 100%;
  opacity: 0.6;
}

body.light_theme .rounded_effect_bottom {
  opacity: 0.2;
}

.started_trading_s .how_get_account_ot {
  z-index: 666;
  position: relative;
  background-image: none !important;
  background-color: transparent;
}


.how_get_account_ot h2 span {
  color: #2563eb;
}

.newhome_maximizeprofit_s h2 {
  letter-spacing: -1px;
}

.newhome_maximizeprofit_s {
  z-index: 666;
  background-color: transparent;
}

.newhome_maximizeprofit_s h2 span {
  color: #2563eb;
}

.newhome_maximizeprofit_s .right_costs_rg ul li {
  color: #2563eb;
}

.newhome_maximizeprofit_s .cta_register_s ul.social_media {
  margin: 100px 0px 20px;
}

.newhome_maximizeprofit_s .trade_btn button {
  display: flex;
  gap: 18px;
  align-items: center;
  border: 1px solid #2563eb;
  color: #2563eb;
}

.newhome_maximizeprofit_s ul.social_media a {
  background-color: #2563eb;
}

.newhome_maximizeprofit_s button.learnbtn a {
  background-color: #2563eb;
}

.newhome_maximizeprofit_s .profit_cost_cnt {
  padding: 0px 0px 0px;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #111;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: #333;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

* {
  scrollbar-width: thin;
  scrollbar-color: #333 #111;
}


.newhome_maximizeprofit_s::after {
  position: absolute;
  right: 0px;
  content: "";
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: 600px;
  background-repeat: no-repeat;
  background-position: right top;
  top: -27%;
  z-index: 333;
  left: inherit;
  width: 100%;
}

.newhome_maximizeprofit_s .container {
  position: relative;
  z-index: 666;
}

.row.cta_register_s {
  align-items: center;
}

.newhome_maximizeprofit_s .row.cta_register_s .profit_cost_cnt {
  padding-top: 40px;
}

.newhome_maximizeprofit_s .trusted_partner {
  padding: 100px 0px;
}

.vector_currency.one {
  top: 0px;
}

.banner_animation_vector.rightside .vector_currency.one {
  top: 0px;
}


body.light_theme .herobanner2 .scan_block {
  background-color: #f5f5f5;
}

body.light_theme .join_group_s button.joinbtn {
  color: #222222;
}

body.light_theme .herobanner2 button.morebtn {
  color: #222;
}

body.light_theme .herobanner2 .scan_cnt {
  color: #222;
}

body.light_theme .herobanner2 .banner_cnt .scan_block p {
  color: #222;
}

body.light_theme .banner_add_slide .slick-dots li button:before {
  background-color: #747474;
}

.market_update_outer .container {
  position: relative;
  z-index: 666;
}

body.light_theme .how_get_account_ot.bgtransparrent_s {
  background-color: transparent;
}

body.light_theme .profit_costs_cta_outer.newhome_maximizeprofit_s {
  background-color: transparent;
}

body.light_theme .started_trading_s .how_get_account_ot {
  background-color: transparent;
}

body.light_theme .trading_platform_section h2 {
  color: #0C0900;
}

body.light_theme .services_block {
  border: 1px solid #dddddd;
  background-color: #f5f5f5;
  color: #000;
}

body.light_theme .services_block p {
  color: #000;
}

body.light_theme .faq_cta_outer .accordion-item {
  color: #141414;
}

body.light_theme .faq_cta_outer .accordion-item h3 button.accordion-button {
  color: #141414;
  border-bottom: 1px solid #a9a9a9;
}

body.light_theme .faq_cta_outer .accordion-item .collapse.show {
  background-color: #f5f5f5;
}

body.light_theme .faq_cta_outer .accordion-item.active h3 button.accordion-button[aria-expanded="true"] {
  background-color: #f5f5f5;
  border-color: #f5f5f5 !important;
}

img.light_m {
  display: none;
}

body.light_theme img.light_m {
  display: flex;
  margin: 0 auto;
}

body.light_theme img.drak_d {
  display: none;
}

body.light_theme .scan_left_s img.light_m {
  margin-left: 0px;
  margin: inherit;
}





@media screen and (max-width:1440px) {

  .hero_section.herobanner2 {
    height: 100%;
    min-height: 100%;
    padding-top: 20px;
    padding-bottom: 15px;
  }

  .banner_animation_vector {
    top: 90px;
  }

  .hero_section.herobanner2 .slick-track {
    gap: 20px;
  }

  .banner_add_slide {
    margin: 60px 0px 40px;
  }

  .rounded_effect_bottom {
    bottom: 190px;
  }

  .newhome_maximizeprofit_s .row.cta_register_s {
    margin-top: 80px;
  }

}

@media screen and (max-width:1200px) {

  .trading_img {
    width: 110px;
  }

  #popup-box.popup-box.homepop_box {
    width: 600px;
    margin: 0 auto;
}

  .newhome_maximizeprofit_s::after {
    background-size: 400px;
    top: -15%;
  }

  .how_get_account_ot ul li p {
    font-size: 18px;
  }


}

@media screen and (max-width:991px) {

  .banner_img {
    width: 50%;
  }

  .herobanner2 .banner_cnt h3 {
    font-size: 30px;
  }

  .herobanner2 .banner_cnt h1 {
    font-size: 24px;
  }

  .newhome_maximizeprofit_s .trusted_partner {
    padding: 60px 0px;
  }


}

@media screen and (max-width:767px) {

  #popup-box.popup-box.homepop_box {
    width: 70%;
}  

  .vector_currency img {
    width: 20px;
    opacity: 0.7;
  }

  .services_block p {
    line-height: 20px;
    padding-top: 5px;
  }

  .herobanner2 .banner_cnt h1 {
    font-size: 18px;
  }

  .herobanner2 .banner_cnt h3 {
    font-size: 22px;
  }

  .how_get_account_ot ul li p {
    font-size: 15px;
  }

  .herobanner2 .scan_block {
    margin: -20px auto;
  }

  .rounded_effect_bottom {
    display: none;
  }

  .banner_add_slide .heighlightcnt img {
    height: 100%;
  }

  .hero_section.herobanner2 {
    padding-bottom: 0px;
  }

  .trading_img {
    right: inherit;
    text-align: center;
    left: inherit;
    margin: 0 auto;
    position: relative;
    top: 0px;
  }

  .services_block {
    text-align: center;
    align-items: center;
  }

  .how_get_account_ot .row .col-sm-4 {
    width: 100%;
  }

  .how_get_account_ot .row .col-sm-8 {
    width: 100%;
  }

  .services_block h4 {
    font-size: 18px;
    margin-top: 24px;
  }

  .newhome_maximizeprofit_s .profit_cost_cnt {
    text-align: center;
  }

  .newhome_maximizeprofit_s .row .col-sm-4 {
    width: 100%;
  }

  .newhome_maximizeprofit_s .row .col-sm-8 {
    width: 100%;
  }

  .newhome_maximizeprofit_s button.learnbtn {
    margin: 0 auto;
  }

  .newhome_maximizeprofit_s .trade_btn button {
    margin: 0 auto;
  }

  .how_get_account_ot .row .col-sm-6 {
    width: 100%;
  }

  .main_marker_summary .row.align-items-center .col-sm-8 {
    width: 100%;
  }

  .newhome_maximizeprofit_s .trusted_partner {
    padding: 30px 0px 10px;
  }

  .newhome_maximizeprofit_s .row.cta_register_s .profit_cost_cnt {
    padding-top: 0px;
  }

  .newhome_maximizeprofit_s .row.cta_register_s {
    margin-top: 30px;
  }

  .newhome_maximizeprofit_s {
    padding-top: 15px;
  }

  .newhome_maximizeprofit_s::after {
    background-size: 300px;
    opacity: 0.5;
  }

  .services_block {
    min-height: 100%;
  }

  .newhome_maximizeprofit_s .cta_vector {
    padding-top: 24px;
  }

  .how_get_account_ot.trade_app__app {
    padding-top: 15px;
  }


}

.herobanner2 .scan_block {
  background-color: #0C0900;
  margin: -10px auto;
}

.banner_add_slide {
  margin: 80px 0px 60px;
  position: relative;
  z-index: 6666;
}

.banner_add_slide .heighlightcnt img {
  border-radius: 13px;
}

.banner_add_slide .slick-dots li button:before {
  font-size: 0px;
  background-color: #FFFBFB;
  left: 0;
  width: 10px;
  border-radius: 50px;
  height: 10px;
}

body .banner_add_slide .slick-dots li.slick-active button:before {
  width: 24px;
  background-color: #2563eb;
}

body .banner_add_slide .slick-dots li button {
  width: auto;
  height: auto;
}

body .banner_add_slide .slick-dots li {
  width: auto;
  height: auto;
}

body .banner_add_slide .slick-dots li.slick-active {
  width: 24px;
}


.herobanner2 {
  font-family: "Afacad", sans-serif;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
}

h2 {
  font-family: "Afacad", sans-serif;
}

h3 {
  font-family: "Afacad", sans-serif;
}

.how_get_account_ot ul li {
  font-family: "Afacad", sans-serif;
}

.how_get_account_ot ul li p {
  font-size: 22px;
}

.herobanner2 .banner_cnt {
  padding-top: 100px;
}

.herobanner2 .banner_cnt h3 {
  font-size: 40px;
  font-weight: 400;
  text-transform: capitalize;
}

.herobanner2 .banner_cnt h1 span {
  color: #2563eb;
}

.uptates_sm.market_update_outer h2 span {
  color: #2563eb;
}

.uptates_sm .trade_btn button {
  display: flex;
  align-items: center;
  gap: 24px;
}

.services_block {
  font-family: "Afacad", sans-serif;
}

.services_block h4 {
  font-size: 24px;
  font-weight: 600;
}

.services_block p {
  line-height: 24px;
}


.started_trading_s {
  position: relative;
}

.started_trading_s::before {
  position: absolute;
  right: 0px;
  content: "";
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: 28%;
  background-repeat: no-repeat;
  background-position: right;
  top: -620px;
  z-index: 333;
  left: inherit;
  width: 100%;
}

.started_trading_s .how_get_account_ot .trade_btn button {
  display: flex;
  align-items: center;
  gap: 24px;
}

.started_trading_s .trading_platform_section {
  background-color: transparent;
  position: relative;
  z-index: 666;
}

.started_trading_s .trading_platform_section h2 span {
  color: #2563eb;
  display: inline;
  padding-right: 10px;
}

.started_trading_s .services_block:hover {
  background-color: transparent;
}

.started_trading_s::after {
  position: absolute;
  left: 0px;
  content: "";
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 40%;
  background-repeat: no-repeat;
  background-position: left bottom;
  bottom: -300px;
  z-index: 333;
  right: inherit;
  width: 100%;
  opacity: 0.6;
}

body.light_theme .rounded_effect_bottom {
  opacity: 0.2;
}

.started_trading_s .how_get_account_ot {
  z-index: 666;
  position: relative;
  background-image: none !important;
  background-color: transparent;
}


.how_get_account_ot h2 span {
  color: #2563eb;
}

.newhome_maximizeprofit_s h2 {
  letter-spacing: -1px;
}

.newhome_maximizeprofit_s {
  z-index: 666;
  background-color: transparent;
}

.newhome_maximizeprofit_s h2 span {
  color: #2563eb;
}

.newhome_maximizeprofit_s .right_costs_rg ul li {
  color: #2563eb;
}

.newhome_maximizeprofit_s .cta_register_s ul.social_media {
  margin: 100px 0px 20px;
}

.newhome_maximizeprofit_s .trade_btn button {
  display: flex;
  gap: 18px;
  align-items: center;
  border: 1px solid #2563eb;
  color: #2563eb;
}

.newhome_maximizeprofit_s ul.social_media a {
  background-color: #2563eb;
}

.newhome_maximizeprofit_s button.learnbtn a {
  background-color: #2563eb;
}

.newhome_maximizeprofit_s .profit_cost_cnt {
  padding: 0px 0px 0px;
}


.newhome_maximizeprofit_s::after {
  position: absolute;
  right: 0px;
  content: "";
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: 600px;
  background-repeat: no-repeat;
  background-position: right top;
  top: -27%;
  z-index: 333;
  left: inherit;
  width: 100%;
}

.newhome_maximizeprofit_s .container {
  position: relative;
  z-index: 666;
}

.row.cta_register_s {
  align-items: center;
}

.newhome_maximizeprofit_s .row.cta_register_s .profit_cost_cnt {
  padding-top: 40px;
}

.newhome_maximizeprofit_s .trusted_partner {
  padding: 100px 0px;
}

.vector_currency.one {
  top: 0px;
}

.banner_animation_vector.rightside .vector_currency.one {
  top: 0px;
}


body.light_theme .herobanner2 .scan_block {
  background-color: #f5f5f5;
}

body.light_theme .join_group_s button.joinbtn {
  color: #222222;
}

body.light_theme .herobanner2 button.morebtn {
  color: #222;
}

body.light_theme .herobanner2 .scan_cnt {
  color: #222;
}

body.light_theme .herobanner2 .banner_cnt .scan_block p {
  color: #222;
}

body.light_theme .banner_add_slide .slick-dots li button:before {
  background-color: #747474;
}

.market_update_outer .container {
  position: relative;
  z-index: 666;
}

body.light_theme .how_get_account_ot.bgtransparrent_s {
  background-color: transparent;
}

body.light_theme .profit_costs_cta_outer.newhome_maximizeprofit_s {
  background-color: transparent;
}

body.light_theme .started_trading_s .how_get_account_ot {
  background-color: transparent;
}

body.light_theme .trading_platform_section h2 {
  color: #0C0900;
}

body.light_theme .services_block {
  border: 1px solid #dddddd;
  background-color: #f5f5f5;
  color: #000;
}

body.light_theme .services_block p {
  color: #000;
}

body.light_theme .faq_cta_outer .accordion-item {
  color: #141414;
}

body.light_theme .faq_cta_outer .accordion-item h3 button.accordion-button {
  color: #141414;
  border-bottom: 1px solid #a9a9a9;
}

body.light_theme .faq_cta_outer .accordion-item .collapse.show {
  background-color: #f5f5f5;
}

body.light_theme .faq_cta_outer .accordion-item.active h3 button.accordion-button[aria-expanded="true"] {
  background-color: #f5f5f5;
  border-color: #f5f5f5 !important;
}

img.light_m {
  display: none;
}

body.light_theme img.light_m {
  display: flex;
  margin: 0 auto;
}

body.light_theme img.drak_d {
  display: none;
}

body.light_theme .scan_left_s img.light_m {
  margin-left: 0px;
  margin: inherit;
}





@media screen and (max-width:1440px) {

  .hero_section.herobanner2 {
    height: 100%;
    min-height: 100%;
    padding-top: 20px;
    padding-bottom: 15px;
  }

  .banner_animation_vector {
    top: 90px;
  }

  .hero_section.herobanner2 .slick-track {
    gap: 20px;
  }

  .banner_add_slide {
    margin: 60px 0px 40px;
  }

  .rounded_effect_bottom {
    bottom: 190px;
  }

  .newhome_maximizeprofit_s .row.cta_register_s {
    margin-top: 80px;
  }

}

@media screen and (max-width:1200px) {

  .trading_img {
    width: 110px;
  }

  .newhome_maximizeprofit_s::after {
    background-size: 400px;
    top: -15%;
  }

  .how_get_account_ot ul li p {
    font-size: 18px;
  }


}

@media screen and (max-width:991px) {

  .banner_img {
    width: 50%;
  }

  .herobanner2 .banner_cnt h3 {
    font-size: 30px;
  }

  .herobanner2 .banner_cnt h1 {
    font-size: 24px;
  }

  .newhome_maximizeprofit_s .trusted_partner {
    padding: 60px 0px;
  }


}

@media screen and (max-width:767px) {

  .vector_currency img {
    width: 20px;
    opacity: 0.7;
  }

  .banner_img {
    width: 65% !important;
}

  body .newhome_maximizeprofit_s .row.cta_register_s {
    margin-top: 15px;
  }

  .services_block p {
    line-height: 20px;
    padding-top: 5px;
  }

  .herobanner2 .banner_cnt h1 {
    font-size: 18px;
  }

  .herobanner2 .banner_cnt h3 {
    font-size: 22px;
  }

  .how_get_account_ot ul li p {
    font-size: 15px;
  }

  .herobanner2 .scan_block {
    margin: -20px auto;
  }

  .rounded_effect_bottom {
    display: none;
  }

  .banner_add_slide .heighlightcnt img {
    height: 100%;
  }

  .hero_section.herobanner2 {
    padding-bottom: 0px;
  }

  .trading_img {
    right: inherit;
    text-align: center;
    left: inherit;
    margin: 0 auto;
    position: relative;
    top: 0px;
  }

  .services_block {
    text-align: center;
    align-items: center;
  }

  .how_get_account_ot .row .col-sm-4 {
    width: 100%;
  }

  .how_get_account_ot .row .col-sm-8 {
    width: 100%;
  }

  .services_block h4 {
    font-size: 18px;
    margin-top: 24px;
  }

  .newhome_maximizeprofit_s .profit_cost_cnt {
    text-align: center;
  }

  .newhome_maximizeprofit_s .row .col-sm-4 {
    width: 100%;
  }

  .newhome_maximizeprofit_s .row .col-sm-8 {
    width: 100%;
  }

  .newhome_maximizeprofit_s button.learnbtn {
    margin: 0 auto;
  }

  .newhome_maximizeprofit_s .trade_btn button {
    margin: 0 auto;
  }

  .how_get_account_ot .row .col-sm-6 {
    width: 100%;
  }

  .main_marker_summary .row.align-items-center .col-sm-8 {
    width: 100%;
  }

  .newhome_maximizeprofit_s .trusted_partner {
    padding: 30px 0px 10px;
  }

  .newhome_maximizeprofit_s .row.cta_register_s .profit_cost_cnt {
    padding-top: 0px;
  }

  .newhome_maximizeprofit_s .row.cta_register_s {
    margin-top: 30px;
  }

  .newhome_maximizeprofit_s {
    padding-top: 15px;
  }

  .newhome_maximizeprofit_s::after {
    background-size: 300px;
    opacity: 0.5;
  }

  .services_block {
    min-height: 100%;
  }

  .newhome_maximizeprofit_s .cta_vector {
    padding-top: 24px;
  }

  .how_get_account_ot.trade_app__app {
    padding-top: 15px;
  }


}


@media screen and (max-width:580px) { 

  #popup-box.popup-box.homepop_box {
        width: 85%;
    }

  }`, "",{"version":3,"sources":["webpack://./src/ui/Pages/LandingPage/home.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,OAAO;EACP,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,iCAAiC;EACjC,yDAA6E;EAC7E,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yDAAmF;EACnF,oBAAoB;EACpB,4BAA4B;EAC5B,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yDAAoF;EACpF,oBAAoB;EACpB,4BAA4B;EAC5B,gCAAgC;EAChC,cAAc;EACd,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,6BAA6B;AAC/B;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;;AAGA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yDAA0E;EAC1E,sBAAsB;EACtB,4BAA4B;EAC5B,8BAA8B;EAC9B,SAAS;EACT,YAAY;EACZ,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;;;;;AAMA;;EAEE;IACE,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;AAEF;;AAEA;;EAEE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,cAAc;AAClB;;EAEE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;;AAGF;;AAEA;;EAEE;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;;AAGF;;AAEA;;EAEE;IACE,UAAU;AACd;;EAEE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;;AAGF;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,OAAO;EACP,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,iCAAiC;EACjC,yDAA6E;EAC7E,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yDAAmF;EACnF,oBAAoB;EACpB,4BAA4B;EAC5B,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yDAAoF;EACpF,oBAAoB;EACpB,4BAA4B;EAC5B,gCAAgC;EAChC,cAAc;EACd,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,6BAA6B;AAC/B;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;;AAGA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yDAA0E;EAC1E,sBAAsB;EACtB,4BAA4B;EAC5B,8BAA8B;EAC9B,SAAS;EACT,YAAY;EACZ,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;;;;;AAMA;;EAEE;IACE,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;AAEF;;AAEA;;EAEE;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;;AAGF;;AAEA;;EAEE;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;;AAGF;;AAEA;;EAEE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,qBAAqB;AACzB;;EAEE;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;;AAGF;;;AAGA;;EAEE;QACM,UAAU;IACd;;EAEF","sourcesContent":[".herobanner2 .scan_block {\n  background-color: #0C0900;\n  margin: -10px auto;\n}\n\n.banner_add_slide {\n  margin: 80px 0px 60px;\n  position: relative;\n  z-index: 6666;\n}\n\n.banner_add_slide .heighlightcnt img {\n  border-radius: 13px;\n}\n\n.banner_add_slide .slick-dots li button:before {\n  font-size: 0px;\n  background-color: #FFFBFB;\n  left: 0;\n  width: 10px;\n  border-radius: 50px;\n  height: 10px;\n}\n\nbody .banner_add_slide .slick-dots li.slick-active button:before {\n  width: 24px;\n  background-color: #2563eb;\n}\n\n#popup-box.popup-box.homepop_box {\n    width: 700px;\n}\n\nbody .banner_add_slide .slick-dots li button {\n  width: auto;\n  height: auto;\n}\n\nbody .banner_add_slide .slick-dots li {\n  width: auto;\n  height: auto;\n}\n\nbody .banner_add_slide .slick-dots li.slick-active {\n  width: 24px;\n}\n\n\n.herobanner2 {\n  font-family: \"Afacad\", sans-serif;\n  background-image: url('../../../../public/images/new_img/hero_bannerbg2.svg');\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\nh2 {\n  font-family: \"Afacad\", sans-serif;\n}\n\nh3 {\n  font-family: \"Afacad\", sans-serif;\n}\n\n.how_get_account_ot ul li {\n  font-family: \"Afacad\", sans-serif;\n}\n\n.how_get_account_ot ul li p {\n  font-size: 22px;\n}\n\n.herobanner2 .banner_cnt {\n  padding-top: 100px;\n}\n\n.herobanner2 .banner_cnt h3 {\n  font-size: 35px;\n  font-weight: 400;\n  text-transform: capitalize;\n}\n\n.herobanner2 .banner_cnt h1 span {\n  color: #2563eb;\n}\n\n.uptates_sm.market_update_outer h2 span {\n  color: #2563eb;\n}\n\n.uptates_sm .trade_btn button {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.services_block {\n  font-family: \"Afacad\", sans-serif;\n}\n\n.services_block h4 {\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.services_block p {\n  line-height: 24px;\n}\n.started_trading_s {\n  position: relative;\n}\n\n.started_trading_s::before {\n  position: absolute;\n  right: 0px;\n  content: \"\";\n  height: 100%;\n  background-image: url('../../../../public/images/new_img/get_standerdbg_after.svg');\n  background-size: 28%;\n  background-repeat: no-repeat;\n  background-position: right;\n  top: -620px;\n  z-index: 333;\n  left: inherit;\n  width: 100%;\n}\n\n.started_trading_s .how_get_account_ot .trade_btn button {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.started_trading_s .trading_platform_section {\n  background-color: transparent;\n  position: relative;\n  z-index: 666;\n}\n\n.started_trading_s .trading_platform_section h2 span {\n  color: #2563eb;\n  display: inline;\n  padding-right: 10px;\n}\n\n.started_trading_s .services_block:hover {\n  background-color: transparent;\n}\n\n.started_trading_s::after {\n  position: absolute;\n  left: 0px;\n  content: \"\";\n  height: 100%;\n  background-image: url('../../../../public/images/new_img/get_standerdbg_before.svg');\n  background-size: 40%;\n  background-repeat: no-repeat;\n  background-position: left bottom;\n  bottom: -300px;\n  z-index: 333;\n  right: inherit;\n  width: 100%;\n  opacity: 0.6;\n}\n\nbody.light_theme .rounded_effect_bottom {\n  opacity: 0.2;\n}\n\n.started_trading_s .how_get_account_ot {\n  z-index: 666;\n  position: relative;\n  background-image: none !important;\n  background-color: transparent;\n}\n\n\n.how_get_account_ot h2 span {\n  color: #2563eb;\n}\n\n.newhome_maximizeprofit_s h2 {\n  letter-spacing: -1px;\n}\n\n.newhome_maximizeprofit_s {\n  z-index: 666;\n  background-color: transparent;\n}\n\n.newhome_maximizeprofit_s h2 span {\n  color: #2563eb;\n}\n\n.newhome_maximizeprofit_s .right_costs_rg ul li {\n  color: #2563eb;\n}\n\n.newhome_maximizeprofit_s .cta_register_s ul.social_media {\n  margin: 100px 0px 20px;\n}\n\n.newhome_maximizeprofit_s .trade_btn button {\n  display: flex;\n  gap: 18px;\n  align-items: center;\n  border: 1px solid #2563eb;\n  color: #2563eb;\n}\n\n.newhome_maximizeprofit_s ul.social_media a {\n  background-color: #2563eb;\n}\n\n.newhome_maximizeprofit_s button.learnbtn a {\n  background-color: #2563eb;\n}\n\n.newhome_maximizeprofit_s .profit_cost_cnt {\n  padding: 0px 0px 0px;\n}\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #111;\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #333;\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n* {\n  scrollbar-width: thin;\n  scrollbar-color: #333 #111;\n}\n\n\n.newhome_maximizeprofit_s::after {\n  position: absolute;\n  right: 0px;\n  content: \"\";\n  height: 100%;\n  background-image: url('../../../../public/images/new_img/ctabg_after.svg');\n  background-size: 600px;\n  background-repeat: no-repeat;\n  background-position: right top;\n  top: -27%;\n  z-index: 333;\n  left: inherit;\n  width: 100%;\n}\n\n.newhome_maximizeprofit_s .container {\n  position: relative;\n  z-index: 666;\n}\n\n.row.cta_register_s {\n  align-items: center;\n}\n\n.newhome_maximizeprofit_s .row.cta_register_s .profit_cost_cnt {\n  padding-top: 40px;\n}\n\n.newhome_maximizeprofit_s .trusted_partner {\n  padding: 100px 0px;\n}\n\n.vector_currency.one {\n  top: 0px;\n}\n\n.banner_animation_vector.rightside .vector_currency.one {\n  top: 0px;\n}\n\n\nbody.light_theme .herobanner2 .scan_block {\n  background-color: #f5f5f5;\n}\n\nbody.light_theme .join_group_s button.joinbtn {\n  color: #222222;\n}\n\nbody.light_theme .herobanner2 button.morebtn {\n  color: #222;\n}\n\nbody.light_theme .herobanner2 .scan_cnt {\n  color: #222;\n}\n\nbody.light_theme .herobanner2 .banner_cnt .scan_block p {\n  color: #222;\n}\n\nbody.light_theme .banner_add_slide .slick-dots li button:before {\n  background-color: #747474;\n}\n\n.market_update_outer .container {\n  position: relative;\n  z-index: 666;\n}\n\nbody.light_theme .how_get_account_ot.bgtransparrent_s {\n  background-color: transparent;\n}\n\nbody.light_theme .profit_costs_cta_outer.newhome_maximizeprofit_s {\n  background-color: transparent;\n}\n\nbody.light_theme .started_trading_s .how_get_account_ot {\n  background-color: transparent;\n}\n\nbody.light_theme .trading_platform_section h2 {\n  color: #0C0900;\n}\n\nbody.light_theme .services_block {\n  border: 1px solid #dddddd;\n  background-color: #f5f5f5;\n  color: #000;\n}\n\nbody.light_theme .services_block p {\n  color: #000;\n}\n\nbody.light_theme .faq_cta_outer .accordion-item {\n  color: #141414;\n}\n\nbody.light_theme .faq_cta_outer .accordion-item h3 button.accordion-button {\n  color: #141414;\n  border-bottom: 1px solid #a9a9a9;\n}\n\nbody.light_theme .faq_cta_outer .accordion-item .collapse.show {\n  background-color: #f5f5f5;\n}\n\nbody.light_theme .faq_cta_outer .accordion-item.active h3 button.accordion-button[aria-expanded=\"true\"] {\n  background-color: #f5f5f5;\n  border-color: #f5f5f5 !important;\n}\n\nimg.light_m {\n  display: none;\n}\n\nbody.light_theme img.light_m {\n  display: flex;\n  margin: 0 auto;\n}\n\nbody.light_theme img.drak_d {\n  display: none;\n}\n\nbody.light_theme .scan_left_s img.light_m {\n  margin-left: 0px;\n  margin: inherit;\n}\n\n\n\n\n\n@media screen and (max-width:1440px) {\n\n  .hero_section.herobanner2 {\n    height: 100%;\n    min-height: 100%;\n    padding-top: 20px;\n    padding-bottom: 15px;\n  }\n\n  .banner_animation_vector {\n    top: 90px;\n  }\n\n  .hero_section.herobanner2 .slick-track {\n    gap: 20px;\n  }\n\n  .banner_add_slide {\n    margin: 60px 0px 40px;\n  }\n\n  .rounded_effect_bottom {\n    bottom: 190px;\n  }\n\n  .newhome_maximizeprofit_s .row.cta_register_s {\n    margin-top: 80px;\n  }\n\n}\n\n@media screen and (max-width:1200px) {\n\n  .trading_img {\n    width: 110px;\n  }\n\n  #popup-box.popup-box.homepop_box {\n    width: 600px;\n    margin: 0 auto;\n}\n\n  .newhome_maximizeprofit_s::after {\n    background-size: 400px;\n    top: -15%;\n  }\n\n  .how_get_account_ot ul li p {\n    font-size: 18px;\n  }\n\n\n}\n\n@media screen and (max-width:991px) {\n\n  .banner_img {\n    width: 50%;\n  }\n\n  .herobanner2 .banner_cnt h3 {\n    font-size: 30px;\n  }\n\n  .herobanner2 .banner_cnt h1 {\n    font-size: 24px;\n  }\n\n  .newhome_maximizeprofit_s .trusted_partner {\n    padding: 60px 0px;\n  }\n\n\n}\n\n@media screen and (max-width:767px) {\n\n  #popup-box.popup-box.homepop_box {\n    width: 70%;\n}  \n\n  .vector_currency img {\n    width: 20px;\n    opacity: 0.7;\n  }\n\n  .services_block p {\n    line-height: 20px;\n    padding-top: 5px;\n  }\n\n  .herobanner2 .banner_cnt h1 {\n    font-size: 18px;\n  }\n\n  .herobanner2 .banner_cnt h3 {\n    font-size: 22px;\n  }\n\n  .how_get_account_ot ul li p {\n    font-size: 15px;\n  }\n\n  .herobanner2 .scan_block {\n    margin: -20px auto;\n  }\n\n  .rounded_effect_bottom {\n    display: none;\n  }\n\n  .banner_add_slide .heighlightcnt img {\n    height: 100%;\n  }\n\n  .hero_section.herobanner2 {\n    padding-bottom: 0px;\n  }\n\n  .trading_img {\n    right: inherit;\n    text-align: center;\n    left: inherit;\n    margin: 0 auto;\n    position: relative;\n    top: 0px;\n  }\n\n  .services_block {\n    text-align: center;\n    align-items: center;\n  }\n\n  .how_get_account_ot .row .col-sm-4 {\n    width: 100%;\n  }\n\n  .how_get_account_ot .row .col-sm-8 {\n    width: 100%;\n  }\n\n  .services_block h4 {\n    font-size: 18px;\n    margin-top: 24px;\n  }\n\n  .newhome_maximizeprofit_s .profit_cost_cnt {\n    text-align: center;\n  }\n\n  .newhome_maximizeprofit_s .row .col-sm-4 {\n    width: 100%;\n  }\n\n  .newhome_maximizeprofit_s .row .col-sm-8 {\n    width: 100%;\n  }\n\n  .newhome_maximizeprofit_s button.learnbtn {\n    margin: 0 auto;\n  }\n\n  .newhome_maximizeprofit_s .trade_btn button {\n    margin: 0 auto;\n  }\n\n  .how_get_account_ot .row .col-sm-6 {\n    width: 100%;\n  }\n\n  .main_marker_summary .row.align-items-center .col-sm-8 {\n    width: 100%;\n  }\n\n  .newhome_maximizeprofit_s .trusted_partner {\n    padding: 30px 0px 10px;\n  }\n\n  .newhome_maximizeprofit_s .row.cta_register_s .profit_cost_cnt {\n    padding-top: 0px;\n  }\n\n  .newhome_maximizeprofit_s .row.cta_register_s {\n    margin-top: 30px;\n  }\n\n  .newhome_maximizeprofit_s {\n    padding-top: 15px;\n  }\n\n  .newhome_maximizeprofit_s::after {\n    background-size: 300px;\n    opacity: 0.5;\n  }\n\n  .services_block {\n    min-height: 100%;\n  }\n\n  .newhome_maximizeprofit_s .cta_vector {\n    padding-top: 24px;\n  }\n\n  .how_get_account_ot.trade_app__app {\n    padding-top: 15px;\n  }\n\n\n}\n\n.herobanner2 .scan_block {\n  background-color: #0C0900;\n  margin: -10px auto;\n}\n\n.banner_add_slide {\n  margin: 80px 0px 60px;\n  position: relative;\n  z-index: 6666;\n}\n\n.banner_add_slide .heighlightcnt img {\n  border-radius: 13px;\n}\n\n.banner_add_slide .slick-dots li button:before {\n  font-size: 0px;\n  background-color: #FFFBFB;\n  left: 0;\n  width: 10px;\n  border-radius: 50px;\n  height: 10px;\n}\n\nbody .banner_add_slide .slick-dots li.slick-active button:before {\n  width: 24px;\n  background-color: #2563eb;\n}\n\nbody .banner_add_slide .slick-dots li button {\n  width: auto;\n  height: auto;\n}\n\nbody .banner_add_slide .slick-dots li {\n  width: auto;\n  height: auto;\n}\n\nbody .banner_add_slide .slick-dots li.slick-active {\n  width: 24px;\n}\n\n\n.herobanner2 {\n  font-family: \"Afacad\", sans-serif;\n  background-image: url('../../../../public/images/new_img/hero_bannerbg2.svg');\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\nh2 {\n  font-family: \"Afacad\", sans-serif;\n}\n\nh3 {\n  font-family: \"Afacad\", sans-serif;\n}\n\n.how_get_account_ot ul li {\n  font-family: \"Afacad\", sans-serif;\n}\n\n.how_get_account_ot ul li p {\n  font-size: 22px;\n}\n\n.herobanner2 .banner_cnt {\n  padding-top: 100px;\n}\n\n.herobanner2 .banner_cnt h3 {\n  font-size: 40px;\n  font-weight: 400;\n  text-transform: capitalize;\n}\n\n.herobanner2 .banner_cnt h1 span {\n  color: #2563eb;\n}\n\n.uptates_sm.market_update_outer h2 span {\n  color: #2563eb;\n}\n\n.uptates_sm .trade_btn button {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.services_block {\n  font-family: \"Afacad\", sans-serif;\n}\n\n.services_block h4 {\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.services_block p {\n  line-height: 24px;\n}\n\n\n.started_trading_s {\n  position: relative;\n}\n\n.started_trading_s::before {\n  position: absolute;\n  right: 0px;\n  content: \"\";\n  height: 100%;\n  background-image: url('../../../../public/images/new_img/get_standerdbg_after.svg');\n  background-size: 28%;\n  background-repeat: no-repeat;\n  background-position: right;\n  top: -620px;\n  z-index: 333;\n  left: inherit;\n  width: 100%;\n}\n\n.started_trading_s .how_get_account_ot .trade_btn button {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.started_trading_s .trading_platform_section {\n  background-color: transparent;\n  position: relative;\n  z-index: 666;\n}\n\n.started_trading_s .trading_platform_section h2 span {\n  color: #2563eb;\n  display: inline;\n  padding-right: 10px;\n}\n\n.started_trading_s .services_block:hover {\n  background-color: transparent;\n}\n\n.started_trading_s::after {\n  position: absolute;\n  left: 0px;\n  content: \"\";\n  height: 100%;\n  background-image: url('../../../../public/images/new_img/get_standerdbg_before.svg');\n  background-size: 40%;\n  background-repeat: no-repeat;\n  background-position: left bottom;\n  bottom: -300px;\n  z-index: 333;\n  right: inherit;\n  width: 100%;\n  opacity: 0.6;\n}\n\nbody.light_theme .rounded_effect_bottom {\n  opacity: 0.2;\n}\n\n.started_trading_s .how_get_account_ot {\n  z-index: 666;\n  position: relative;\n  background-image: none !important;\n  background-color: transparent;\n}\n\n\n.how_get_account_ot h2 span {\n  color: #2563eb;\n}\n\n.newhome_maximizeprofit_s h2 {\n  letter-spacing: -1px;\n}\n\n.newhome_maximizeprofit_s {\n  z-index: 666;\n  background-color: transparent;\n}\n\n.newhome_maximizeprofit_s h2 span {\n  color: #2563eb;\n}\n\n.newhome_maximizeprofit_s .right_costs_rg ul li {\n  color: #2563eb;\n}\n\n.newhome_maximizeprofit_s .cta_register_s ul.social_media {\n  margin: 100px 0px 20px;\n}\n\n.newhome_maximizeprofit_s .trade_btn button {\n  display: flex;\n  gap: 18px;\n  align-items: center;\n  border: 1px solid #2563eb;\n  color: #2563eb;\n}\n\n.newhome_maximizeprofit_s ul.social_media a {\n  background-color: #2563eb;\n}\n\n.newhome_maximizeprofit_s button.learnbtn a {\n  background-color: #2563eb;\n}\n\n.newhome_maximizeprofit_s .profit_cost_cnt {\n  padding: 0px 0px 0px;\n}\n\n\n.newhome_maximizeprofit_s::after {\n  position: absolute;\n  right: 0px;\n  content: \"\";\n  height: 100%;\n  background-image: url('../../../../public/images/new_img/ctabg_after.svg');\n  background-size: 600px;\n  background-repeat: no-repeat;\n  background-position: right top;\n  top: -27%;\n  z-index: 333;\n  left: inherit;\n  width: 100%;\n}\n\n.newhome_maximizeprofit_s .container {\n  position: relative;\n  z-index: 666;\n}\n\n.row.cta_register_s {\n  align-items: center;\n}\n\n.newhome_maximizeprofit_s .row.cta_register_s .profit_cost_cnt {\n  padding-top: 40px;\n}\n\n.newhome_maximizeprofit_s .trusted_partner {\n  padding: 100px 0px;\n}\n\n.vector_currency.one {\n  top: 0px;\n}\n\n.banner_animation_vector.rightside .vector_currency.one {\n  top: 0px;\n}\n\n\nbody.light_theme .herobanner2 .scan_block {\n  background-color: #f5f5f5;\n}\n\nbody.light_theme .join_group_s button.joinbtn {\n  color: #222222;\n}\n\nbody.light_theme .herobanner2 button.morebtn {\n  color: #222;\n}\n\nbody.light_theme .herobanner2 .scan_cnt {\n  color: #222;\n}\n\nbody.light_theme .herobanner2 .banner_cnt .scan_block p {\n  color: #222;\n}\n\nbody.light_theme .banner_add_slide .slick-dots li button:before {\n  background-color: #747474;\n}\n\n.market_update_outer .container {\n  position: relative;\n  z-index: 666;\n}\n\nbody.light_theme .how_get_account_ot.bgtransparrent_s {\n  background-color: transparent;\n}\n\nbody.light_theme .profit_costs_cta_outer.newhome_maximizeprofit_s {\n  background-color: transparent;\n}\n\nbody.light_theme .started_trading_s .how_get_account_ot {\n  background-color: transparent;\n}\n\nbody.light_theme .trading_platform_section h2 {\n  color: #0C0900;\n}\n\nbody.light_theme .services_block {\n  border: 1px solid #dddddd;\n  background-color: #f5f5f5;\n  color: #000;\n}\n\nbody.light_theme .services_block p {\n  color: #000;\n}\n\nbody.light_theme .faq_cta_outer .accordion-item {\n  color: #141414;\n}\n\nbody.light_theme .faq_cta_outer .accordion-item h3 button.accordion-button {\n  color: #141414;\n  border-bottom: 1px solid #a9a9a9;\n}\n\nbody.light_theme .faq_cta_outer .accordion-item .collapse.show {\n  background-color: #f5f5f5;\n}\n\nbody.light_theme .faq_cta_outer .accordion-item.active h3 button.accordion-button[aria-expanded=\"true\"] {\n  background-color: #f5f5f5;\n  border-color: #f5f5f5 !important;\n}\n\nimg.light_m {\n  display: none;\n}\n\nbody.light_theme img.light_m {\n  display: flex;\n  margin: 0 auto;\n}\n\nbody.light_theme img.drak_d {\n  display: none;\n}\n\nbody.light_theme .scan_left_s img.light_m {\n  margin-left: 0px;\n  margin: inherit;\n}\n\n\n\n\n\n@media screen and (max-width:1440px) {\n\n  .hero_section.herobanner2 {\n    height: 100%;\n    min-height: 100%;\n    padding-top: 20px;\n    padding-bottom: 15px;\n  }\n\n  .banner_animation_vector {\n    top: 90px;\n  }\n\n  .hero_section.herobanner2 .slick-track {\n    gap: 20px;\n  }\n\n  .banner_add_slide {\n    margin: 60px 0px 40px;\n  }\n\n  .rounded_effect_bottom {\n    bottom: 190px;\n  }\n\n  .newhome_maximizeprofit_s .row.cta_register_s {\n    margin-top: 80px;\n  }\n\n}\n\n@media screen and (max-width:1200px) {\n\n  .trading_img {\n    width: 110px;\n  }\n\n  .newhome_maximizeprofit_s::after {\n    background-size: 400px;\n    top: -15%;\n  }\n\n  .how_get_account_ot ul li p {\n    font-size: 18px;\n  }\n\n\n}\n\n@media screen and (max-width:991px) {\n\n  .banner_img {\n    width: 50%;\n  }\n\n  .herobanner2 .banner_cnt h3 {\n    font-size: 30px;\n  }\n\n  .herobanner2 .banner_cnt h1 {\n    font-size: 24px;\n  }\n\n  .newhome_maximizeprofit_s .trusted_partner {\n    padding: 60px 0px;\n  }\n\n\n}\n\n@media screen and (max-width:767px) {\n\n  .vector_currency img {\n    width: 20px;\n    opacity: 0.7;\n  }\n\n  .banner_img {\n    width: 65% !important;\n}\n\n  body .newhome_maximizeprofit_s .row.cta_register_s {\n    margin-top: 15px;\n  }\n\n  .services_block p {\n    line-height: 20px;\n    padding-top: 5px;\n  }\n\n  .herobanner2 .banner_cnt h1 {\n    font-size: 18px;\n  }\n\n  .herobanner2 .banner_cnt h3 {\n    font-size: 22px;\n  }\n\n  .how_get_account_ot ul li p {\n    font-size: 15px;\n  }\n\n  .herobanner2 .scan_block {\n    margin: -20px auto;\n  }\n\n  .rounded_effect_bottom {\n    display: none;\n  }\n\n  .banner_add_slide .heighlightcnt img {\n    height: 100%;\n  }\n\n  .hero_section.herobanner2 {\n    padding-bottom: 0px;\n  }\n\n  .trading_img {\n    right: inherit;\n    text-align: center;\n    left: inherit;\n    margin: 0 auto;\n    position: relative;\n    top: 0px;\n  }\n\n  .services_block {\n    text-align: center;\n    align-items: center;\n  }\n\n  .how_get_account_ot .row .col-sm-4 {\n    width: 100%;\n  }\n\n  .how_get_account_ot .row .col-sm-8 {\n    width: 100%;\n  }\n\n  .services_block h4 {\n    font-size: 18px;\n    margin-top: 24px;\n  }\n\n  .newhome_maximizeprofit_s .profit_cost_cnt {\n    text-align: center;\n  }\n\n  .newhome_maximizeprofit_s .row .col-sm-4 {\n    width: 100%;\n  }\n\n  .newhome_maximizeprofit_s .row .col-sm-8 {\n    width: 100%;\n  }\n\n  .newhome_maximizeprofit_s button.learnbtn {\n    margin: 0 auto;\n  }\n\n  .newhome_maximizeprofit_s .trade_btn button {\n    margin: 0 auto;\n  }\n\n  .how_get_account_ot .row .col-sm-6 {\n    width: 100%;\n  }\n\n  .main_marker_summary .row.align-items-center .col-sm-8 {\n    width: 100%;\n  }\n\n  .newhome_maximizeprofit_s .trusted_partner {\n    padding: 30px 0px 10px;\n  }\n\n  .newhome_maximizeprofit_s .row.cta_register_s .profit_cost_cnt {\n    padding-top: 0px;\n  }\n\n  .newhome_maximizeprofit_s .row.cta_register_s {\n    margin-top: 30px;\n  }\n\n  .newhome_maximizeprofit_s {\n    padding-top: 15px;\n  }\n\n  .newhome_maximizeprofit_s::after {\n    background-size: 300px;\n    opacity: 0.5;\n  }\n\n  .services_block {\n    min-height: 100%;\n  }\n\n  .newhome_maximizeprofit_s .cta_vector {\n    padding-top: 24px;\n  }\n\n  .how_get_account_ot.trade_app__app {\n    padding-top: 15px;\n  }\n\n\n}\n\n\n@media screen and (max-width:580px) { \n\n  #popup-box.popup-box.homepop_box {\n        width: 85%;\n    }\n\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
